module.exports = "/_next/static/images/cd5978f42d897c83603cdf4a8f1f3b4e-nubanker-tpm@0.5x.jpg.webp";